import { render } from "./TemplateDropDown.vue?vue&type=template&id=64ae64ec&scoped=true"
import script from "./TemplateDropDown.vue?vue&type=script&lang=js"
export * from "./TemplateDropDown.vue?vue&type=script&lang=js"

import "./TemplateDropDown.vue?vue&type=style&index=0&id=64ae64ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ae64ec"]])

export default __exports__